import { render } from "./ViewAdd.vue?vue&type=template&id=5590846e&scoped=true"
import script from "./ViewAdd.vue?vue&type=script&lang=js"
export * from "./ViewAdd.vue?vue&type=script&lang=js"

import "./ViewAdd.vue?vue&type=style&index=0&id=5590846e&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5590846e"]])

export default __exports__